$padding: 20px;

.selectable-results {
  position: relative;
  height: 100%;
  min-height: 540px;

  &__spinner {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    text-align: center;
    padding-top: 192px;
    padding-bottom: 192px;

    &__element {
      position: sticky;
      top: 50%;
      z-index: 99;
    }
  }

  &__selectable-result {
    margin-bottom: 30px;
  }

  &__error-message {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    background-color: $ui-yellow-minus-1;
    color: $ui-blue;
    padding: $padding;
    margin-top: 48px;

    ui-icon {
      margin-left: 0;
    }

    &-text {
      padding: 5px;
      padding-left: $padding;
    }
  }
}
